module.exports = __webpack_public_path__ + "static/media/downloadOn_playStore.11dce92a.png";